// extracted by mini-css-extract-plugin
module.exports = {"select":"BuscarPaciente_select__1-RO1","selectControl":"BuscarPaciente_selectControl__2HCpJ"};